"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RcReactTablePageInfo extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "updatePageInfo", event => {
      const {
        page,
        totalPages,
        canNext,
        canPrevious
      } = event.detail;
      this.setState({
        page,
        totalPages,
        canNext,
        canPrevious
      });
    });
    this.state = {
      page: 0,
      canNext: false,
      canPrevious: false,
      totalPages: 0
    };
    this.updatePageInfo = this.updatePageInfo.bind(this);
    this.changePage = this.changePage.bind(this);
    const {
      tableIdentifer
    } = props;
    window.document.addEventListener(`rc-react-table-pageinfo-update-${tableIdentifer}`, this.updatePageInfo);
  }
  componentWillUnmount() {
    const {
      tableIdentifer
    } = this.props;
    window.document.removeEventListener(`rc-react-table-pageinfo-update-${tableIdentifer}`, this.updatePageInfo);
  }
  changePage(page) {
    const {
      tableIdentifer
    } = this.props;
    let event;
    if (typeof Event === 'function') {
      event = new window.CustomEvent(`rc-react-table-page-change-${tableIdentifer}`, {
        bubbles: true,
        detail: {
          page
        }
      });
    } else {
      event = window.document.createEvent('Event');
      event.initEvent(`rc-react-table-page-change-${tableIdentifer}`, true, true);
      event.detail = {
        page
      };
    }
    window.document.dispatchEvent(event);
  }
  static getPaginationControl(goToPage, className) {
    if (className === 'pagination-previous') {
      return '<';
    }
    if (className === 'pagination-next') {
      return '>';
    }
    return goToPage;
  }
  generateLi(goToPage, className) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: goToPage + className
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: `${goToPage}`,
      className: className,
      "aria-label": `Goto page ${goToPage}`,
      onClick: e => {
        e.preventDefault();
        this.changePage(goToPage - 1);
      }
    }, RcReactTablePageInfo.getPaginationControl(goToPage, className)));
  }
  render() {
    const {
      page,
      totalPages,
      canNext,
      canPrevious
    } = this.state;
    let middlePages = [];
    const currentPage = page + 1;
    if (totalPages <= 1) return null;
    if (totalPages === 2) middlePages = [];else if (totalPages === 3) middlePages = [2];else if (totalPages === 4) middlePages = [2, 3];else if (totalPages === 5) middlePages = [2, 3, 4];else if (currentPage < 5) middlePages = [2, 3, 4];else if (currentPage > totalPages - 4) middlePages = [totalPages - 3, totalPages - 2, totalPages - 1];else middlePages = [currentPage - 1, currentPage, currentPage + 1];
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: "pagination is-large is-centered is-marginless",
      role: "navigation",
      "aria-label": "pagination"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "pagination-list"
    }, canPrevious ? this.generateLi(currentPage - 1, 'pagination-previous') : null, this.generateLi(1, currentPage === 1 ? 'pagination-link is-current' : 'pagination-link'), currentPage > 4 ? /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "pagination-ellipsis"
    }, "\u2026")) : null, middlePages.map(mp => this.generateLi(mp, mp === currentPage ? 'pagination-link is-current' : 'pagination-link')), currentPage < totalPages - 3 ? /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "pagination-ellipsis"
    }, "\u2026")) : null, this.generateLi(totalPages, currentPage === totalPages ? 'pagination-link is-current' : 'pagination-link'), canNext ? this.generateLi(currentPage + 1, 'pagination-next') : null));
  }
}
exports.default = RcReactTablePageInfo;
RcReactTablePageInfo.propTypes = {
  tableIdentifer: _propTypes.default.string
};
RcReactTablePageInfo.defaultProps = {
  tableIdentifer: 'default'
};
//# sourceMappingURL=RcReactTablePagination.js.map